import { StrictMode, createContext, useContext } from "react";
import { createRoot } from "react-dom/client";
import { FollowMemberButtonWrapper } from "./components/follow-member/follow-member-button-wrapper";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../js/api/queryClient";

const FollowMemberContext = createContext();
export const useFollowMember = () => useContext(FollowMemberContext);
function FollowMemberProvider({ data, children }) {
  return (
    <FollowMemberContext.Provider value={data}>
      {children}
    </FollowMemberContext.Provider>
  );
}

function FollowMemberRenderer() {
  const elements = document.querySelectorAll(".react-follow-member");
  if (!elements) return;
  elements.forEach((element) => {
    let initialProps = {};
    try {
      initialProps = JSON.parse(element.getAttribute("data-initial-props"));
    } catch (error) {
      console.error(
        error,
        "Could not parse initial props JSON for FollowMember"
      );
    }
    createRoot(element).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <FollowMemberProvider data={initialProps}>
            <FollowMemberButtonWrapper />
          </FollowMemberProvider>
        </QueryClientProvider>
      </StrictMode>
    );
  });
}

export const initFollowMember = () => {
  if (document.readyState !== "loading") {
    FollowMemberRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", FollowMemberRenderer);
  }
};
